import React from "react";
import Nav from "./Nav";
import Hero from "./Hero";
import EditorialMarquee from "./Marquee";
import Snapshot from "./Snapshot";
import Problem from "./Problem";
import Ecosystem from "./Ecosystem";
import WhyYouTube from "./WhyYouTube";
import Comparison from "./Comparison";
import Roadmap from "./Roadmap";
import Story from "./Story";
import Proof from "./Proof";
import Transformation from "./Transformation";
import Curriculum from "./Curriculum";
import Toolkit from "./Toolkit";
import Support from "./Support";
import Testimonials from "./Testimonials";
import WhoFor from "./WhoFor";
import Objections from "./Objections";
import Offer from "./Offer";
import Guarantee from "./Guarantee";
import FAQ from "./FAQ";
import FinalClose from "./FinalClose";
import Footer from "./Footer";
import LeadModal from "./LeadModal";
import { MobileCTA, BackToTop } from "./UtilityBars";
import { LeadProvider } from "./shared";

export default function Landing() {
  return (
    <LeadProvider>
      <div className="grain relative">
        <Nav />
        <main>
          <Hero />
          <EditorialMarquee />
          <Snapshot />
          <Problem />
          <Ecosystem />
          <WhyYouTube />
          <Comparison />
          <Roadmap />
          <Story />
          <Proof />
          <Transformation />
          <Curriculum />
          <Toolkit />
          <Support />
          <Testimonials />
          <WhoFor />
          <Objections />
          <Offer />
          <Guarantee />
          <FAQ />
          <FinalClose />
        </main>
        <Footer />
        <LeadModal />
        <MobileCTA />
        <BackToTop />
      </div>
    </LeadProvider>
  );
}
